module.exports = __webpack_public_path__ + "img/P150T_weapon_21.ccdd0ca0.png";